import React, {useCallback} from 'react';

import ComboBox, {ComboboxItem, DefaultItem} from '@pb/kit-component-combo-box';

import type {UserEmailLogsCriteria} from '../../typedef';
import type {DictionaryItem} from 'src/openapi/admin/models/DictionaryItem';


type Props = {
    trackedEmailType: DictionaryItem[],
    filter: UserEmailLogsCriteria,
    onChange: (newFilter: UserEmailLogsCriteria) => void,
};

export const EmailTypeFilter = ({filter, onChange, trackedEmailType}: Props) => {
    const setEmailType = useCallback((email: string) => {
        if (onChange) {
            if (email) {
                onChange({...filter, email});
            } else {
                const {email: _email, ...rest} = filter || {};
                onChange(rest);
            }
        }
    }, [filter, onChange]);

    return (
        <div style={{width: 300}}>
            <ComboBox value={filter?.email || ''} onChange={setEmailType}>
                <DefaultItem value="" key="all" caption="All Email Types"/>
                {trackedEmailType.map(({code, description}) => (
                    <ComboboxItem key={code} value={code} caption={description}/>
                ))}
            </ComboBox>
        </div>
    );
};
